import simulationIcon from '@/assets/simulation_icon.svg';
import todoIcon from '@/assets/todo_icon.svg';
import desginIcon from '@/assets/design_icon.svg';
import searchIcon from '@/assets/property_search_icon.svg';
import conceptIcon from '@/assets/concept_sheet_icon.svg';

// サービスの画像と説明文の定義
export type serviceItem = {
  imageSrc: string;
  title: string;
  description: string;
  path: string;
};

export const serviceItems = [
  {
    imageSrc: todoIcon,
    title: '開業TODO',
    description: '開業までにやることをチェックしましょう。',
    path: '/todo'
  },
  {
    imageSrc: conceptIcon,
    title: '店舗コンセプト',
    description: 'まずはお店のコンセプトを決めましょう。',
    path: '/mypage/concept'
  },
  {
    imageSrc: simulationIcon,
    title: '簡易損益シミュレーション',
    description: '簡単５ステップ！あなたのお店の開業計画を作成しましょう。',
    path: '/balance_simulation'
  },
  {
    imageSrc: searchIcon,
    title: '物件検索',
    description: '豊富な空き物件から好みの出店場所を見つけよう。',
    path: '/properties/prefectures'
  },
  {
    imageSrc: desginIcon,
    title: '内装会社マッチング',
    description: '物件が決まったら自分の店舗をデザイン。',
    path: '/design'
  }
];
